export const validateCnpj = (cnpjInput: string): boolean => {
  if (!cnpjInput) return true;

  const cnpj = cnpjInput.replace(/[^0-9A-Z]/gi, '').toUpperCase();

  if (cnpj.length !== 14) {
    return false;
  }

  const sequenciasInvalidas = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999'
  ];
  if (sequenciasInvalidas.includes(cnpj)) {
    return false;
  }

  const getVal = (char: string) => char.charCodeAt(0) - 48;

  let soma = getVal(cnpj[0]) * 5 +
    getVal(cnpj[1]) * 4 +
    getVal(cnpj[2]) * 3 +
    getVal(cnpj[3]) * 2 +
    getVal(cnpj[4]) * 9 +
    getVal(cnpj[5]) * 8 +
    getVal(cnpj[6]) * 7 +
    getVal(cnpj[7]) * 6 +
    getVal(cnpj[8]) * 5 +
    getVal(cnpj[9]) * 4 +
    getVal(cnpj[10]) * 3 +
    getVal(cnpj[11]) * 2;

  let dig1 = 11 - (soma % 11);
  if (dig1 >= 10) dig1 = 0;

  if (dig1 !== getVal(cnpj[12])) {
    return false;
  }

  soma = getVal(cnpj[0]) * 6 +
    getVal(cnpj[1]) * 5 +
    getVal(cnpj[2]) * 4 +
    getVal(cnpj[3]) * 3 +
    getVal(cnpj[4]) * 2 +
    getVal(cnpj[5]) * 9 +
    getVal(cnpj[6]) * 8 +
    getVal(cnpj[7]) * 7 +
    getVal(cnpj[8]) * 6 +
    getVal(cnpj[9]) * 5 +
    getVal(cnpj[10]) * 4 +
    getVal(cnpj[11]) * 3 +
    (dig1 * 2);

  let dig2 = 11 - (soma % 11);
  if (dig2 >= 10) dig2 = 0;

  return dig2 === getVal(cnpj[13]);
}
